import { keycodeRecorder } from '../../recorder/recorder';
import type { PostWatchKey} from "../../define/request";


export const handleRecorder =async (data:PostWatchKey) => {
    return keycodeRecorder.EnableRecording(data)
}